const debug = localStorage.getItem("debug") == "true" || false;

let url =  process.env.URL_API || "https://management.tetglobalservice.it";
if(debug)
    url = "http://localhost:10003"

console.log("url", url, debug, process.env.URL_API);

export const endpoints = {
    GRAPHQL_AUTH: `${url}/api/auth`,
    GRAPHQL_GENERAL: `${url}/api/data`
}

export const captcha = {
    REACT_APP_SITE_KEY: process.env.REACT_APP_SITE_KEY

}

export const VERSION = 'v1.3.28'
export const URL = url
